module.exports = __webpack_public_path__ + "img/almenu_gomb_kutatasok_tudasbazis.e8c0f993.png";